export const defaultConfig = {
  key: 'ui-task1', // 每个ui组件必须有
  type: 'ui-task1', //
  images: {
    taskBg: 'task-bg',
    taskStaus0: 'task-button-status0',
    taskStaus1: 'task-button-status1',
    taskStaus2: 'task-button-status2',
  }, // 每个组件的配置都统一放到images中管理
  layout: {
    // 布局相关的配置统一放到layout中
    wrapper: {
      taskContainer: {
        pc: 'x',
        pt: '911',
      },
      taskBtnPosition: [
        {
          wh: '64 30',
          pl: '264',
          pt: '71',
          giftConfig: '&giftTabId=35&giftId=944',
        },
        {
          wh: '64 30',
          pl: '264',
          pt: '159',
          giftConfig: '&giftTabId=35&giftId=944',
        },
        {
          wh: '64 30',
          pl: '264',
          pt: '247',
          giftConfig: '&giftTabId=35&giftId=944',
        },
        {
          wh: '64 30',
          pl: '264',
          pt: '335',
          giftConfig: '&giftTabId=35&giftId=944',
        },
        {
          wh: '64 30',
          pl: '264',
          pt: '423',
          giftConfig: '&giftTabId=35&giftId=944',
        },
      ],
    }, // 单个ui组件wrapper的ui配置 q-section相关的东西都能进行配置
  },
  config: {
    api: '/api/activities/general/point/task/process',
    componentId: 4,
  }, //每个ui组件的一些配置字段相关的东西
}

import request from '@/core/request'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export const useTask = (uiMeta = defaultConfig) => {
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const componentId = uiMeta.config?.componentId
  const { data: taskData } = useQuery({
    queryKey: ['taskData'],
    queryFn: () => {
      return request.get(uiMeta.config.api, {
        activity_code,
        component_id: componentId,
      })
    },
  })

  const taskBtnPosition = computed(() => {
    return taskData.value?.data?.task_progress.map((item: any, index: number) => {
      return {
        ...item,
        config: uiMeta.layout.wrapper.taskBtnPosition[index],
        btnBg: uiMeta.images[`taskStaus${item.status}` as keyof typeof uiMeta.images],
        giftConfig: uiMeta.layout.wrapper.taskBtnPosition[index].giftConfig,
      }
    })
  })

  return {
    taskBtnPosition,
  }
}
